









































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { UserInfoType } from '../../types/type'
import { UserModule } from '../../store'
@Component({
  name: 'headerUser',
  components: {
    'my-dialog': () => import('./myDialog.vue')
  }
})
export default class HeaderUser extends Vue {
  @Prop({ default: {} }) public userInfo: UserInfoType
  public dialogVisibleUpdatePassword: boolean = false
  public oldPassword: string = ''
  public newPassword: string = ''
  public newPasswordAgain: string = ''

  logoutBtn (): void {
    this.$message.success('成功退出')
    setTimeout(() => {
      UserModule.removeTokenForUser()
      UserModule.removeUserInfoForUser()
      this.$router.push('/login')
      window.location.reload()
    }, 1000)
  }

  async savePassword () {
    try {
      if (!this.oldPassword) return this.$message.warning('请输入旧密码')
      if (!this.newPassword) return this.$message.warning('请输入新密码')
      if (!this.newPasswordAgain) return this.$message.warning('请再次输入新密码')
      if (this.newPasswordAgain !== this.newPassword) return this.$message.warning('两次密码输入不一致')
      let params = {
        newPassword: this.newPassword,
        oldPassword: this.oldPassword
      }
      const { data: result } = await (this as any).$http.sysUserUpdatePassword(
        params
      )
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('密码修改成功，请重新登录')
      this.dialogVisibleUpdatePassword = false
      setTimeout(() => {
        UserModule.removeTokenForUser()
        UserModule.removeUserInfoForUser()
        this.$router.push('/login')
      }, 1000)
    } catch (err) {
      console.log(err)
    }
  }
}
